import { useEffect, useState } from "react";
import { fetchMeetPresence, MeetPresence } from "../../hooks/api/meet";

const POLL_MS = 15_000;

/**
 * Presencia de la sesión (paciente conectado o no, minutos de tolerancia) según psi-video, consultada cada pocos segundos.
 * Si falla, queda el último dato bueno: nunca traba la llamada (ver `decideExit`).
 */
export function useMeetPresence(
  linkToken: string,
  sessionId: string,
  enabled = true,
): MeetPresence | null {
  const [presence, setPresence] = useState<MeetPresence | null>(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const load = () => {
      fetchMeetPresence(linkToken, sessionId)
        .then((p) => {
          if (!cancelled) setPresence(p);
        })
        .catch(() => undefined);
    };
    load();
    const t = setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [linkToken, sessionId, enabled]);
  return presence;
}
